module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Orange-5bc3ac81f954904f21e8e68a9af30172.svg";